import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { Trip } from '../models/multi-trip-view.model';
import { mockTripViewData } from './mockdata';
import { environment } from 'src/environments/environment';

interface TripDetails{
  buid: string;
  tripIds: string[];
  tripType: string;
}

interface TripDetailsResponse {
  tripDetails:any;
  cabDetails:any;
}

export interface TripTrackingData {
  legUUID: string;
  imei: string;
  fixedDevice: boolean;
  'trip-id': string;
}

interface TripTrackingResponse {
  [imei: string]: {
    sequenceId: number;
    milestones: {
      mBearing: number;
      mSpeed: number;
      mStep: number;
      mAccuracy: number;
      timeStamp: string;
      time: number;
      type: number;
      latitude: number;
      longitude: number;
    }[];
    cabLocation: {
      mBearing: number;
      mSpeed: number;
      mStep: number;
      mAccuracy: number;
      timeStamp: string;
      time: number;
      type: number;
      latitude: number;
      longitude: number;
    };
  };
}
  
@Injectable({
  providedIn: 'root'
})
export class MultiTripViewService {
  buid: string = 'qa-ETS2';
  tripIds: string[] = [];
  tripType: string = 'PLANNED';
  isTrackingFromFixedDevice: boolean = false;
  private apiUrl ;
  apiResponse: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedTrips:TripDetails[] = []
  noTripsFound:BehaviorSubject<any> = new BehaviorSubject<any>(false);

  constructor(private http: HttpClient) {}

  getTripDetails(): Observable<any[]> {
    const tripDetailsPayload = this.tripIds
    if(!tripDetailsPayload.length){
      this.noTripsFound.next(true)
      return of([])
    }
    return this.http.post<any[]>(`${environment.API_URL}/tracking/buid/${this.buid}/multi-trip`, tripDetailsPayload).pipe(
      tap(res => this.apiResponse.next(res))
    );
  }

  getTripTrackingData(tripTrackingData: TripTrackingData[]): Observable<any[]> {
    tripTrackingData = tripTrackingData.map(trip => {
      trip.fixedDevice = this.isTrackingFromFixedDevice;
      return trip;
    });
    return this.http.post<any[]>(`${environment.API_URL}/tracking/buid/${this.buid}/get-tracking-data/multi-trip`, tripTrackingData);
  }

  setTrackingFromFixedDevice(isFixedDevice: boolean): void {
    this.isTrackingFromFixedDevice = isFixedDevice;
  }
  
  goToETSDashboard() {
    this.getEtsUrl().subscribe((url:string)=>{
      let pathname=url+"/master.jsp#transport-dashboard"
      window.open(pathname,'_top');
    })
  }

  getEtsUrl() {
     return this.http.get(environment.API_URL+"/dashboard/"+this.buid+"/url",{ responseType: 'text' })
  }
}
